import { FinancialStrength } from './FinancialStrength'
import { reactToCwp } from '../../../../common/react-utils'

export default reactToCwp(FinancialStrength)
